import { Box, Flex, Input, Textarea } from '@chakra-ui/react'
import { useEffect, useState } from 'react'

import { FormField } from '../../../components/FormField'
import { FormModal } from '../../../components/FormModal'
import { useAppToast } from '../../../helpers'
import { IBlackList } from '../../../interfaces/BlackList/IBlackList'
import { BlackListService } from '../../../services/BlackList/BlackListService'

interface IBlackListModalProps {
  isOpen: boolean
  onClose: () => void
  data: IBlackList | null
}

export default function BlackListPageModal({ isOpen, onClose, data }: IBlackListModalProps) {
  const service = new BlackListService()
  const toast = useAppToast()
  const [saving, setSaving] = useState(false)
  const [form, setForm] = useState<Partial<IBlackList>>({
    reason: '',
    email: ''
  })
  const [formErrors, setFormErrors] = useState<Record<string, string>>({})

  useEffect(() => {
    if (data) {
      setForm({
        reason: data.reason,
        email: data.email
      })
    } else {
      setForm({
        reason: '',
        email: ''
      })
    }
    setFormErrors({})
  }, [data, isOpen])

  const handleSave = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    setFormErrors({})
    setSaving(true)
    try {
      if (data?.id) {
        await service.update(data.id, form as IBlackList)
      } else {
        await service.create(form as IBlackList)
      }

      onClose()
    } catch (err) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const error = err as any
      if (error.response?.status === 422) setFormErrors(error.response.data.errors)
      else toast.error('Erro ao salvar e-mail', err)
    } finally {
      setSaving(false)
    }
  }

  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title={`${data ? 'Editar' : 'Cadastrar'} E-mail`}
      onSubmit={handleSave}
      isLoading={saving}
    >
      <Flex direction="column" gap={3}>
        <Box>
          <FormField label="E-mail" error={formErrors.email}>
            <Input value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} disabled={saving} />
          </FormField>
        </Box>
        <Box>
          <FormField label="Motivação" error={formErrors.reason}>
            <Textarea
              value={form.reason ?? ''}
              onChange={(e) => setForm({ ...form, reason: e.target.value })}
              disabled={saving}
            />
          </FormField>
        </Box>
      </Flex>
    </FormModal>
  )
}
